import { GridColumnProps } from '@progress/kendo-react-grid'
import { NameDto } from 'api/Common/Types'
import { UserFilterKey, UserStatus } from 'api/Identity/Types/UserResponse'
import {
  SelectAssignTableProps,
  SelectItemEvent,
  SelectItemsEvent,
  SelectUsersAssignTable,
} from 'components/SelectOverviewTable/SelectUsersAssignTable'
import { initialState } from 'store/grid'
import { BuildQueryProps, FilterLogic } from 'utils/QueryHelpers'

export interface GridColumn extends GridColumnProps {
  width?: number
}

export type SelectTicketsEvent = SelectItemsEvent
export type SelectTicketEvent = SelectItemEvent

export interface SelectTicketsAssignTableProps extends Omit<SelectAssignTableProps, 'query'> {
  departments?: NameDto[]
}

export const SelectTicketsAssignTable: React.FC<SelectTicketsAssignTableProps> = (props) => {
  const departmentIds = props.departments?.map((x) => x.id) || []
  return <SelectUsersAssignTable {...props} query={createUsersAssignQuery(departmentIds)} />
}

const createUsersAssignQuery = (departmentIds: number[]): BuildQueryProps => {
  const initialGridState = initialState()

  return {
    ...initialGridState.filter,
    logic: FilterLogic.AND,
    defaultFilters: {
      logic: FilterLogic.AND,
      filters: [
        {
          field: UserFilterKey.departments,
          operator: '==',
          value: departmentIds,
        },
        {
          field: UserFilterKey.status,
          operator: '!=',
          value: UserStatus.Locked,
        },
      ],
    },
  }
}
